import BannerRepository from "../api/banner.js"
import "../type/banner.js"

class BannerUseCase {
    constructor() {
        /** @type {BannerRepository}*/
        this.api = new BannerRepository()
    }

    /**
     *
     * @param typeBanner {string}
     * @return {Promise<{data: Banner, err: null}|{data: null, err: ErrorState}>}
     */
    async getAll(banner_page, is_revamp = false) {
        let queries = ""
        if (is_revamp) queries = `status=ACTIVE&banner_page=${banner_page}&is_revamp=${is_revamp}&priority=${is_revamp}`
        else queries = `status=ACTIVE&banner_page=${banner_page}&is_revamp=${is_revamp}`
        const {data, err} = await this.api.getAll(queries)
        if (err && err === "record not found") {
            return {data: null, err: null}
        }
        return {data, err}
    }
}

export default new BannerUseCase()
